import React, { useState, useContext, useEffect } from 'react';
import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import { getDataWithFetch, getLocalStorage, postDataWithFetch, setLocalStorage } from './Utils';
import ApplicationContext from './ApplicationContext';
import "../assets/css/modal.css";  // Ensure these CSS files are available in your project
import "../assets/css/CreditCardForm.css";

const CreditCardForm = ({ isOpen, onClose }) => {
	const data = useContext(ApplicationContext);
    const [isLoading, setIsLoading] = useState(false);
    const [creditCardData, setCreditCardData] = useState({name: "", email: ""});
    const [cardInfoStatusText, setCardInfoStatusText] = useState("Need Input");
    const [nameStatusText, setNameStatusText] = useState("Need Input");
    const [emailStatusText, setEmailStatusText] = useState("Need Input");
    const [paymentInfo, setPaymentInfo] = useState();
    const [alreadyRegistered, setAlreadyRegistered] = useState(false);

	const stripe = useStripe();
	const elements = useElements();

    const onInputChange = (e, name) => {
        let tmpCardInfoStatusText = String(cardInfoStatusText);
        let tmpNameStatusText = String(nameStatusText);
        let tmpEmailStatusText = String(emailStatusText);
    
        // Function to update credit card data and set status messages
        const updateCreditCardData = (fieldName, value) => {
            setCreditCardData(prev => ({ ...prev, [fieldName]: value }));
            return fieldName === 'name' && value.length < 5
                ? 'Name must be greater than 4 characters.'
                : fieldName === 'email' && !e.target.checkValidity()
                ? 'Invalid email address'
                : '';
        };
    
        // Handle Card Element validation
        if (name === 'card-element') {
            tmpCardInfoStatusText = e?.complete ? '' : 'Invalid card details';
            setCardInfoStatusText(tmpCardInfoStatusText);
        } else if (name === 'name' || name === 'email') {
            e.preventDefault();
            const value = e.target.value;
            if (name === 'name') {
                tmpNameStatusText = updateCreditCardData('name', value);
                setNameStatusText(tmpNameStatusText);
            } else if (name === 'email') {
                tmpEmailStatusText = updateCreditCardData('email', value);
                setEmailStatusText(tmpEmailStatusText);
            }
        }
    
        // Check if the form is valid for submission
        const isFormValid = tmpCardInfoStatusText === "" && tmpNameStatusText === "" && tmpEmailStatusText === "";
        // console.log(tmpCardInfoStatusText === "" && tmpNameStatusText === "" && tmpEmailStatusText === "");

        // console.log(tmpCardInfoStatusText === "", tmpCardInfoStatusText, 'tmpCardInfoStatusText');
        // console.log(tmpNameStatusText === "", tmpNameStatusText, 'tmpNameStatusText');
        // console.log(tmpEmailStatusText === "", tmpEmailStatusText, 'tmpEmailStatusText');

        setCanSubmitButton(isFormValid);
        setEmailVerification(!tmpEmailStatusText);
    };

    const [emailVerificationCode, setEmailVerificationCode] = useState("");
    const [completedCheck, setCompletedCheck] = useState(false);
    const onEmailVerification = (e) => {
        e.preventDefault();

        const inputValue = e.target.value;
        const digitCheck = /^\d{0,6}$/.test(inputValue);
        // console.log(inputValue, creditCardData.name, creditCardData.email, digitCheck);

        if (digitCheck) {
            setEmailVerificationCode(inputValue);
        }

        const completedCheck = /^\d{6,6}$/.test(inputValue);
        setCompletedCheck(completedCheck);
    };

    const checkCodeAndLogin = async() => {
        // First check if the validation code is valid first before making payment.
        const isCodeExpiredUrl = `${data.BASE_URL}index.php/verification_codes/isValidCode/${encodeURIComponent(creditCardData.email)}/${emailVerificationCode}`;
        console.log(isCodeExpiredUrl);
        const json = await getDataWithFetch(isCodeExpiredUrl);
        console.log(json ? "true" : "false");

        if (json === true) {
            registerUser();
            onClose(false);
            resetState();  
            data.setAuthToken(authToken);    
        }
        else {
            setEmailStatusText("Email Validation Code is not valid");
        }
    };

    const handleSubscription = async (e) => {
        const makePayment = async() => {
            const cardElement = elements.getElement(CardElement);
    
            const { paymentMethod:paymentInfo, error } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
                billing_details: {
                    name: creditCardData.name,
                    email: creditCardData.email,
                },
            });
        
            if (error) {
                console.error(error);
                return;
            }
        
            const url = `${data.BASE_URL}index.php/stripe_util/subscription`;

            setIsLoading(true);
            document.body.style.cursor = 'wait';

            // console.log('DEBUG:  CreditCardForm - ', url);
            // console.log('DEBUG:  CreditCardForm - ', parms);
            const subscription = await postDataWithFetch(url, {
                'PAYMENT_METHOD_ID': paymentInfo.id,
                'EMAIL': creditCardData.email,
            });
            setPaymentInfo(subscription);
    
            if (subscription.error) {
                console.error(subscription.error.message);
            } else {
                // console.log('Subscription created:', subscription);
                const transactionID = subscription.id;
                setTransactionID(transactionID)
                const amount = subscription.plan.currency; // Amount is usually in cents
                // console.log(amount, typeof amount);
                setCurrency(amount);
                const currency = subscription.plan.amount;
                setAmount(currency);
                const paymentStatus = subscription.status; // Typically 'succeeded' for successful payments
                setPaymentStatus(paymentStatus);

                registerUser(paymentStatus);
                // console.log("on submit status form");
            }
            
            document.body.style.cursor = 'default';
            setIsLoading(false);
        };

        e.preventDefault();

        // console.log(stripe);
        // console.log(elements);

        if (!stripe || !elements) {
			return;
		}

        // First check if the validation code is valid first before making payment.
        const isCodeExpiredUrl = `${data.BASE_URL}index.php/verification_codes/isValidCode/${encodeURIComponent(creditCardData.email)}/${emailVerificationCode}`;
        // console.log(isCodeExpiredUrl);
        const json = await getDataWithFetch(isCodeExpiredUrl);
        // console.log(json);

        if (json === true) {
            makePayment();
        }
        else {
            setEmailStatusText("Email Validation Code is not valid");
        }
    };

    // const fetchPaymentMethod = async(e) => {
    //     const makePayment = async() => {
    //         // Call to the handle the user's payment and get the response and send a confirmation email.
            
    //         // console.log("Processing payment here for $14.95/mo.");
    //         // console.log("Credit Card Data: ", creditCardData);
    //         const url = `${data.BASE_URL}index.php/stripe_util/payment_intent`;
            
    //         const parms = {
    //             CURRENCY_CODE: 'USD',
    //             AMOUNT: 1495
    //         };
    //         // console.log('DEBUG:  CreditCardForm - ', url);
    //         // console.log('DEBUG:  CreditCardForm - ', parms);
            
    //         setIsLoading(true);
    //         document.body.style.cursor = 'wait';
            
    //         const json = await postDataWithFetch(url, parms);
            
    //         document.body.style.cursor = 'default';
    //         setIsLoading(false);
            
    //         if (json) {
    //             // console.log('DEBUG', json);
    //             // console.log('DEBUG', json['client_secret']);
    //             const clientSecret = json['client_secret']
    //             const cardElement = elements.getElement(CardElement);
    //             if (clientSecret) {
    //                 const {name, email} = creditCardData;
    //                 // console.log(name, email);
    //                 const createPaymentMethodParams = {
    //                     type: 'card',
    //                     card: cardElement,
    //                     billing_details: {
    //                         name: name,
    //                         email: email,
    //                     },
    //                 }
    //                 // console.log('CreditCardForm - createPaymentMethodParams', createPaymentMethodParams);
    //                 const res = await stripe.createPaymentMethod(createPaymentMethodParams);
    //                 // console.log("res:  ", res);
    //                 const { paymentMethod:tmpPaymentMethod, error } = res;
    //                 // console.log('CreditCardForm - tmpPaymentMethod', tmpPaymentMethod);
    //                 if (error) {
    //                     console.error("Error creating PaymentMethod:", error);
    //                 } else {
    //                     // console.log("PaymentMethod created:", tmpPaymentMethod);
    //                     setPaymentInfo(tmpPaymentMethod);  // Save the created paymentInfo
    //                     if (tmpPaymentMethod) {
    //                         // console.log('calling confirmPayment here');
    //                         confirmPayment(clientSecret, tmpPaymentMethod);
    //                     }
    //                     // else {
    //                     //     console.log('failing over to the else condition not calling confirmPayment here');
    //                     // }
    //                 }
    //             }
    //         }            
    //     };

    //     e.preventDefault();

    //     // console.log(stripe);
    //     // console.log(elements);

    //     if (!stripe || !elements) {
	// 		return;
	// 	}

    //     // First check if the validation code is valid first before making payment.
    //     const isCodeExpiredUrl = `${data.BASE_URL}index.php/verification_codes/isValidCode/${encodeURIComponent(creditCardData.email)}/${emailVerificationCode}`;
    //     // console.log(isCodeExpiredUrl);
    //     const json = await getDataWithFetch(isCodeExpiredUrl);
    //     // console.log(json);

    //     if (json === true) {
    //         makePayment();
    //     }
    //     else {
    //         setEmailStatusText("Email Validation Code is not valid");
    //     }
    // };

    // const confirmPayment = async(clientSecret, paymentInfo) => {
    //     // console.log("stripe:  ", stripe);
    //     // console.log("elements:  ", elements);
    //     // console.log("clientSecret:  ", clientSecret);
    //     // console.log('inside confirmPayment here');
    //     // console.log(stripe);
    //     // console.log(elements);

    //     if (!stripe || !elements) {
	// 		return;
	// 	}

    //     if (clientSecret) {
    //         // console.log(paymentInfo);
    //         const res = await stripe.confirmCardPayment(clientSecret, {
    //             payment_method: paymentInfo.id,
    //         });
    //         // console.log("confirmPayment:  ", res);
    //         const { error: stripeError, paymentIntent } = res;

    //         if (stripeError) {
    //             console.error(stripeError);
    //             // setErrorMessage(stripeError.message);
    //         }
    //         else if (paymentIntent.status === 'succeeded') {
    //             // console.log('Payment succeeded:', paymentIntent);
    //             // Payment was successful
    //             // console.log('Payment confirmed:', paymentIntent);
    //             // Extract details for confirmation page
    //             const transactionID = paymentIntent.id;
    //             setTransactionID(transactionID)
    //             const amount = paymentIntent.amount; // Amount is usually in cents
    //             // console.log(amount, typeof amount);
    //             setAmount(amount);
    //             const currency = paymentIntent.currency.toUpperCase();
    //             setCurrency(currency);
    //             const paymentStatus = paymentIntent.status; // Typically 'succeeded' for successful payments
    //             setPaymentStatus(paymentStatus);

    //             registerUser(paymentStatus);
    //             // console.log("on submit status form");
    //         }
    //     }
    // };

    const [, setTransactionID] = useState("");
    const [, setAmount] = useState("");
    const [, setCurrency] = useState("");
    // const [transactionID, setTransactionID] = useState("");
    // const [amount, setAmount] = useState("");
    // const [currency, setCurrency] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
 
    const [authToken, setAuthToken] = useState(getLocalStorage('token'));

    const registerUser = async(paymentStatus) => {
        // console.log(`paymentStatus =`, paymentStatus);
        // console.log('DEBUG:', "Entering paymentStatus effect function");
        const {email} = creditCardData;
        const url = `${data.BASE_URL}index.php/user/register`;
        const params = { USERNAME: email, IS_PREMIUM: 'true' };
        // console.log('DEBUG:', `url = ${url}, params = ${JSON.stringify(params)}`);
        const json = await postDataWithFetch(url, params);

        // console.log("json.status = ", json.status);
        if (json.status) {
            // console.log('json.token', json.token);
            setLocalStorage('token', json.token);
            
            // BUG:  This line seems to  be causing a problem it is dismissing the dialog before  the user clicks the close button.
            setAuthToken(json.token);
            data.setAuthToken(json.token);

            // data = { ...data, authToken:json.token };
            // data.authToken = json.token;
            // console.log(json.token);
            setLocalStorage('username', json.user.username);
            setLocalStorage('is_premium', json.user.is_premium);
            // console.log("DEBUG", "Successful login");
        }

        return json;
    };

    const [finishedPayment, setFinishedPayment] = useState(false);

    useEffect(() => {
        if (finishedPayment) {
            setTransactionID("");
            setAmount("");
            setCurrency("");
            setPaymentStatus("");
            setCreditCardData({name: "", email: ""});
            setCardInfoStatusText("Need Input");
            setNameStatusText("Need Input");
            setEmailStatusText("Need Input");
            setPaymentInfo();
            setFinishedPayment(false);
        }
    }, [finishedPayment]);

    const [emailVerification,setEmailVerification] = useState(false);
    const [emailVerificationStatus,setEmailVerificationStatus] = useState("Click below to get the email verification code");
    const [canSubmitButton,setCanSubmitButton] = useState(false);

    const sendValidationCodeEmail = async(sendEmailTemplate) => {
        let endpoint;
        if (sendEmailTemplate === "verification_content") {
            endpoint = "send_email_email_verification_content";
        }
        else { //verification_premium_login
            endpoint = "send_email_email_verification_premium_login";
        }

        const url = `${data.BASE_URL}index.php/email_controller/${endpoint}`;
        const parms = {
            TO: creditCardData?.email,
            NAME: creditCardData?.name,
            SUBJECT: 'Your Verification Code',
        };

        setIsLoading(true);
        document.body.style.cursor = 'wait';

        // console.log('DEBUG:  CreditCardForm - ', url);
        // console.log('DEBUG:  CreditCardForm - ', parms);
        const json = await postDataWithFetch(url, parms);

        document.body.style.cursor = 'default';
        setIsLoading(false);

        // console.log(json.status, json.message);
        setEmailVerificationStatus(json?.message);
    };

    const resetState = () => {
        setIsLoading(false);
        setCreditCardData({name: "", email: ""});
        setCardInfoStatusText("Need Input");
        setNameStatusText("Need Input");
        setEmailStatusText("Need Input");
        setPaymentInfo();
        setAlreadyRegistered(false);
        setEmailVerificationCode("");
        setCompletedCheck(false);
        setTransactionID("");
        setAmount("");
        setCurrency("");
        setPaymentStatus("");
        setFinishedPayment(false);
        setEmailVerification(false);
        setEmailVerificationStatus("Click below to get the email verification code");
        setCanSubmitButton(false);
    };

    return (
		isOpen && (<div className="modalBackground">
			<div className="modalContainer">
                <div className="titleCloseBtn">
					<button onClick={() => {
                        // console.log("on close button");
                        onClose(false);
                        resetState();
                        data.setAuthToken(authToken);
                    }}>X</button>
                </div>
                <div className="title">
                    <h1>Premium content</h1>
                    <p>This section is for subscribers for $14 per month. What you get:</p>
                    <ul className="link-title">
                        <li>US Crude and Petroleum Bi-Weekly Output Reporting.</li>
                        <li>US Energy Sector Insights.</li>
                        <li>Add-ons in the US Energy Sector Reporting if any and / or Applicable.</li>
                    </ul>
                    {/* To see premium content please pay $14.00/month<br/><br/> */}
                    {!paymentInfo && <div className="Container">
                        <div className="FormContainer">
                            <form>
                                <div className="top-container">
                                    <div className="button-container">
                                        <button 
                                            className="card-form-button" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // console.log("clicked already subscribed");
                                                setAlreadyRegistered(!alreadyRegistered);
                                        }}>{!alreadyRegistered ? "Already Subscribed" : "New User"}</button>
                                    </div>
                                </div>

                                {alreadyRegistered && <>

                                    <label>Email Address</label>
                                    <div className="input-container">
                                        <input
                                            type="email"
                                            placeholder="example@example.com"
                                            onChange={e => onInputChange(e, 'email')}
                                            required
                                        />
                                    </div>

                                    <div className="input-container" style={{display: emailVerification ? "" : "none"}}>
                                        <p className="credit-card-status-text">{emailVerificationStatus}</p>
                                    </div>

                                    <label>Email Verification Code</label>
                                    <div className="input-container">
                                        {/* {(() => {
                                            console.log("creditCardData.email = ", creditCardData.email);
                                            console.log("emailVerificationCode = ", emailVerificationCode);
                                        })()} */}
                                        <input 
                                            type="text" 
                                            placeholder="Email Verification Code"
                                            value={emailVerificationCode}
                                            onChange={e => onEmailVerification(e)} 
                                            pattern="\\d{6}"
                                            required
                                        />
                                    </div>

                                    <div className="input-container">
                                        <p className="credit-card-status-text">{emailStatusText}</p>
                                    </div>

                                    <div className="outer-container" >
                                        <div className="button-container">
                                            <button 
                                                className="card-form-button" 
                                                style={{
                                                    opacity: isLoading ? 0.5 : 1
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    // console.log("get email validation code");
                                                    sendValidationCodeEmail("verification_premium_login");
                                            }}>Get Verification Code</button>
                                        </div>
                                    </div>

                                    <div className="outer-container" >
                                        <div className="button-container">
                                            <button 
                                                className={`card-form-button `} 
                                                style={{
                                                    opacity: isLoading ? 0.5 : 1
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    // console.log("login to an existing premium account");
                                                    checkCodeAndLogin();
                                                }}>Login Premium User</button>
                                        </div>
                                    </div>
                                </>}

                                {!alreadyRegistered && <>
                                    <div className="card-element-outer-container">
                                        <div className="card-element-inner-container">
                                            <CardElement 
                                                options={{
                                                    style: {
                                                        base: {
                                                            color: '#000',
                                                        },
                                                        invalid: {
                                                            color: '#e5424d',
                                                        },
                                                    },
                                                    hidePostalCode: false,
                                                }} 
                                                onChange={e => onInputChange(e, 'card-element')}
                                            />
                                        </div>
                                    </div>

                                    <div className="input-container">
                                        <p className="credit-card-status-text">{cardInfoStatusText}</p>
                                    </div>

                                    <label>Card Holder</label>
                                    <div className="input-container">
                                        <input 
                                            type="text" 
                                            placeholder="Example User"
                                            onChange={e => onInputChange(e, 'name')} 
                                            required
                                        />
                                    </div>

                                    <div className="input-container">
                                        <p className="credit-card-status-text">{nameStatusText}</p>
                                    </div>

                                    <label>Email Address</label>
                                    <div className="input-container">
                                        <input
                                            type="email"
                                            placeholder="example@example.com"
                                            onChange={e => onInputChange(e, 'email')}
                                            required
                                        />
                                    </div>

                                    <label style={{display: emailVerification ? "" : "none"}}>Email Verification Code</label>
                                    <div className="input-container" style={{display: emailVerification ? "" : "none"}}>
                                        <input 
                                            type="text" 
                                            placeholder="Email Verification Code"
                                            value={emailVerificationCode}
                                            onChange={e => onEmailVerification(e)} 
                                            pattern="\\d{6}"
                                            required
                                        />
                                    </div>

                                    <div className="input-container" style={{display: emailVerification ? "" : "none"}}>
                                        <p className="credit-card-status-text">{emailVerificationStatus}</p>
                                    </div>

                                    <div className="button-container" style={{display: emailVerification ? "" : "none"}}>
                                        <button 
                                            className="card-form-button" 
                                            style={{
                                                opacity: isLoading ? 0.5 : 1
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                sendValidationCodeEmail("verification_content");
                                        }}>Get Verification Code</button>
                                    </div>

                                    <div className="input-container">
                                        <p className="credit-card-status-text">{emailStatusText}</p>
                                    </div>

                                    <div className="button-container">
                                        <button 
                                            className={`card-form-button ${(!canSubmitButton || !completedCheck) ? "disabled" : ""}`} 
                                            style={{
                                                opacity: isLoading ? 0.5 : 1
                                            }}
                                            disabled={(!canSubmitButton || !completedCheck)}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // console.log("clicked the pay button");
                                                // console.log("Credit Card Data: ", creditCardData);
                                                // fetchPaymentMethod(e);
                                                handleSubscription(e);
                                            }}>Pay</button>
                                    </div>
                                </>}
                            </form>
                        </div>
                    </div>}
                    {paymentInfo && <div className="Container">
                        <h1>Payment Method Successfully submitted please confirm payment below</h1>
                        {/* <h3>Transaction ID:  {transactionID}</h3> */}
                        {/* <h3>Amount:  {(amount/100).toFixed(2)} {currency.toUpperCase()}</h3> */}
                        <h3>Account Status:  {paymentStatus}</h3>
                        <button 
                            className="card-form-button" onClick={(e) => {
                                e.preventDefault();
                                // console.log("on click close button here");
                                setFinishedPayment(true);
                                onClose(false);
                                resetState();
                                data.setAuthToken(authToken);
                        }}>Close</button>
                    </div>}
                </div>
            </div>
        </div>)
    );
};

export default CreditCardForm;
